module.exports = __webpack_public_path__ + "static/img/27-北京市海淀北部新区实验学校(小学部).2b1c19f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/27-北京市海淀北部新区实验学校(小学部).png
// module id = cGsw
// module chunks = 0